import ls from "local-storage";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function getBrandColors(brands) {
  if (!brands?.length) return [];
  const colors = [
    "#FF5733",
    "#33A8FF",
    "#FF33A8",
    "#33FF8C",
    "#F3FF33",
    "#8C33FF",
    "#FF8C33",
    "#33FFF3",
    "#FF3333",
    "#338CFF",
    "#FF33F6",
    "#33FFDA",
    "#F67533",
    "#7546FF",
    "#33FF57",
    "#A833FF",
    "#FFF933",
    "#FF5A33",
    "#33FFD7",
    "#3357FF"
  ];

  return brands.map((_, index) => colors[index % colors.length]);
}

export function dropDownOnChangeHandleAllOrOthers(selectedOptions, setState) {
  if (selectedOptions?.length > 1) {
    // when user selected "All" remove other options
    if (
      selectedOptions.at(-1)?.label?.toLowerCase()?.startsWith("all")
    ) {
      setState(selectedOptions.pop());
      return;
    }

    // when user selects option other then "All" and "All" is also selected, remove "All"
    if (
      selectedOptions?.findIndex((i) =>
        i.label?.toLowerCase()?.startsWith("all")
      ) !== -1
    ) {
      console.log('🚀new selected options ', selectedOptions.filter((i) => !i.label?.toLowerCase()?.startsWith("all")))
      setState(
        selectedOptions.filter((i) => !i.label?.toLowerCase()?.startsWith("all"))
      );
      return;
    }
  }

  setState(selectedOptions);
}

export function handleErrorResponse(error) {
  if (error.response.status === 403) {
    toast.error(error.response.data.Message);
    ls.clear("token");
    ls.clear("brands");
    window.location.href = "/login";
  }
}
